import { cn } from '@/lib/utils';

/**
 * Tokens partilhados entre `SettingsLayout` e `Sidebar`.
 * Hover usa `--primary-subtle` / `--primary` (indigo/roxo do DS), não cinza `surface`
 * (evita halo azul-acinzentado estranho no hover).
 */
export const LAYOUT_NAV_SECTION_LABEL_CLASS =
    'metric-label text-text-muted';

export function cnLayoutNavRow(isActive: boolean): string {
    return cn(
        'transition-colors',
        isActive
            ? 'bg-brand-50 font-medium text-brand-600'
            : 'text-gray-500 hover:bg-surface-1 hover:text-brand-600'
    );
}

/** Ícones: repousam em gray-500; ativo e hover em brand-600. */
export function cnLayoutNavIcon(isActive: boolean): string {
    return cn(
        'shrink-0 transition-colors',
        isActive ? 'text-brand-600' : 'text-gray-500 group-hover:text-brand-600'
    );
}

/** Item de nav em Configurações (hub mobile + sidebar desktop). */
export const SETTINGS_NAV_ITEM_CLASS =
    'group flex min-h-11 w-full items-center gap-s3 rounded-lg px-s3 py-s2 text-left text-sm font-medium touch-manipulation focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background';

/** Grid da barra inferior mobile — 6 colunas iguais (5 rotas + Mais). */
export const MOBILE_BOTTOM_NAV_GRID_CLASS =
    'grid w-full min-w-0 grid-cols-6 items-end gap-0 px-1 pb-0.5 md:hidden';

/**
 * Safe-area do topo no shell autenticado (PWA standalone / notch).
 * `env()` é 0 quando a status bar já empurra o webview — sem gap duplicado.
 */
export const MOBILE_SHELL_TOP_SAFE_CLASS = 'max-md:pt-[env(safe-area-inset-top)]';

/**
 * Clearance inferior único: bottom nav (~4.5rem) + home indicator.
 * Fonte de verdade para páginas com scroll interno (DRY / PWA).
 * Strings literais completas — o scanner do Tailwind precisa ver a classe inteira.
 */
export const MOBILE_CONTENT_BOTTOM_PAD_CLASS =
    'pb-[max(5.5rem,calc(env(safe-area-inset-bottom)+4.5rem))]';

/** Mesmo clearance, só no breakpoint mobile (chat lista, etc.). */
export const MOBILE_ONLY_CONTENT_BOTTOM_PAD_CLASS =
    'max-md:pb-[max(5.5rem,calc(env(safe-area-inset-bottom)+4.5rem))]';

/** Item da barra inferior mobile — alvo ≥44px; ativo em primary. */
export function cnMobileBottomNavItem(): string {
    return cn(
        'flex min-h-11 min-w-0 flex-col items-center justify-end gap-1 touch-manipulation transition-colors',
        'px-0.5 py-1.5',
        'bg-transparent hover:bg-transparent active:bg-transparent'
    );
}

export function cnMobileBottomNavIcon(isActive: boolean): string {
    return cn(
        'h-5 w-5 shrink-0 transition-colors',
        isActive ? 'text-primary' : 'text-text-muted'
    );
}

export function cnMobileBottomNavLabel(isActive: boolean): string {
    return cn(
        'w-full text-center text-[10px] font-medium leading-none transition-colors',
        isActive ? 'text-primary' : 'text-text-muted'
    );
}
